export {};
//# sourceMappingURL=Image.types.js.map